
    $(document).ready(function(){
      console.log("down theme")
      
if (!$(this).hasClass("template-collection")) {

  var item_count = $( ".collection__infinite-container .product-item" ).length;
  if(item_count == 0){


  var link = window.location.href;
  var array = link.split('+');
      console.log('array -- '+array);
    console.log('leng -- '+array.length);

       var leng = array.length;
    if(leng > 1){
    
   
      var a ='';
      var i;
      for (i = 0; i < array.length - 1; ++i) {
            if(i == 0){
              a += array[i];
             }else{
               a += '+'+array[i];
            }

      }
      $(location).prop('href', a);
    }
  }
}
});
     